import { map, mergeDeepRight } from 'ramda'

const pages =
  [
    {
      path: 'login',
      component: () => import(/* webpackChunkName: "h5-login" */ '@/views/h5/login/index')
    },
    {
      path: 'sms-login',
      name: 'h5-sms-login',
      component: () => import(/* webpackChunkName: "h5-sms-login" */ '@/views/h5/login/h5-sms-login')
    }
  ] |> map(mergeDeepRight({ meta: { requireLogin: false, notShowDialog: true } }))

export default pages
